// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"bf8efae3","41":"602d1c02","42":"fb49e9da","75":"3e26d1f5","205":"f6215f17","387":"5978f66f","408":"4b337b7c","624":"a3ca8a38","740":"29b0a59e","790":"ce67788f","844":"a4078f8c","895":"f77c1b8f","973":"59513ccd"}[chunkId] + ".chunk.js";
};